import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit {

  accountCategory: string;
  
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
  }

}
